export const requestPokemons = (state) => {
    return state.pokemonsPage.pokemons
};

export const requestCurrentNumber = (state) => {
    return state.pokemonsPage.currentNumber 
};

export const requestCurrentPage = (state) => {
    return state.pokemonsPage.currentPage
};

